/*!
VueLayers
Vue 2 components to work with OpenLayers

@package vuelayers
@author Vladimir Vershinin <ghettovoice@gmail.com>
@version 0.7.5
@license MIT
@copyright (c) 2017, Vladimir Vershinin <ghettovoice@gmail.com>
*/
'use strict';

var core = require('../core');

var MAPBOX_URL_TEMPLATE = 'https://{a-c}.tiles.mapbox.com/v4/{mapId}/{z}/{x}/{y}{tileNameSuffix}.{tileFormat}?access_token={accessToken}';
var MAPBOX_ATTRIBUTIONS = '&copy; <a href="https://www.mapbox.com/">MapBox</a>, ' + new Date().getFullYear();

var props = {
  accessToken: {
    type: String,
    required: true
  },
  attributions: {
    type: [String, Array],
    default: MAPBOX_ATTRIBUTIONS
  },
  mapId: {
    type: String,
    required: true
  },
  projection: {
    type: String,
    default: core.EPSG_3857
  },
  tileFormat: {
    type: String,
    default: core.TILE_FORMAT
  },
  url: {
    type: String,
    default: MAPBOX_URL_TEMPLATE
  }
};

var computed = {
  /**
   * @type {string}
   */
  tileNameSuffix: function tileNameSuffix() {
    return _tileNameSuffix(this.tilePixelRatio);
  },

  /**
   * @type {string[]}
   */
  urlTokens: function urlTokens() {
    return ['mapId', 'accessToken', 'tileNameSuffix', 'tileFormat'];
  }
};

var Source = {
  name: 'vl-source-mapbox',
  mixins: [core.xyzSource],
  props: props,
  computed: computed

  /**
   * @param {number} [ratio]
   * @returns {number}
   * @private
   */
};function tileRatio(ratio) {
  ratio = core.coalesce(ratio, 1);

  return ratio > 1 ? 2 : 1;
}

/**
 * @param {number} [ratio]
 * @returns {string}
 * @private
 */
function _tileNameSuffix(ratio) {
  ratio = tileRatio(ratio);

  return ratio > 1 ? ['@', ratio, 'x'].join('') : '';
}

var index = {
  Source: Source,
  install: function install(Vue) {
    Vue.component(Source.name, Source);
  }
};

module.exports = index;

//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./~/vuelayers/lib/mapbox-source/index.js
// module id = 1186
// module chunks = 1